import { IntegrationPageActionsProps } from './IntegrationPage';
import ExactOnlineLogo from '../../../assets/exact_online_logo.png';
import SnelStartLogo from '../../../assets/snelstart_logo.png';
import eBoekhoudenLogo from '../../../assets/eboekhouden_logo.png';
import MoneybirdLogo from '../../../assets/moneybird_logo.png';
import IspVisionLogo from '../../../assets/isp_vision_logo.png';
import AsperionLogo from '../../../assets/asperion_logo.png';
import ExactIntegrationForm from './exact/ExactIntegrationForm';
import EBoekhoudenIntegrationForm from './eboekhouden/EBoekhoudenIntegrationForm';
import ExactIntegrationPageContent from './exact/ExactIntegrationPageContent';
import ExactIntegrationPageActions from './exact/ExactIntegrationPageActions';
import EBoekhoudenIntegrationPageActions from './eboekhouden/EBoekhoudenIntegrationPageActions';
import EBoekhoudenIntegrationPageContent from './eboekhouden/EBoekhoudenIntegrationPageContent';
import MoneybirdIntegrationForm from './moneybird/MoneybirdIntegrationForm';
import MoneybirdIntegrationPageActions from './moneybird/MoneybirdIntegrationPageActions';
import MoneybirdIntegrationPageContent from './moneybird/MoneybirdIntegrationPageContent';
import SnelStartIntegrationForm from './snelstart/SnelStartIntegrationForm';
import SnelStartIntegrationPageActions from './snelstart/SnelStartIntegrationPageActions';
import SnelStartIntegrationPageContent from './snelstart/SnelStartIntegrationPageContent';
import AsperionIntegrationForm from './asperion/AsperionIntegrationForm';
import AsperionIntegrationPageActions from './asperion/AsperionIntegrationPageActions';
import AsperionIntegrationPageContent from './asperion/AsperionIntegrationPageContent';
import IspVisionIntegrationPageContent from './ispvision/IspVisionIntegrationPageContent';
import IspVisionIntegrationPageActions from './ispvision/IspVisionIntegrationPageActions';
import IspVisionApiKeyForm from './ispvision/IspVisionApiKeyForm';
import MkgLogo from '../../../assets/mkg_logo.svg';
import MkgIntegrationPageContent from './mkg/MkgIntegrationPageContent';
import MkgIntegrationPageActions from './mkg/MkgIntegrationPageActions';
import MkgIntegrationForm from './mkg/MkgIntegrationForm';

interface AvailableIntegration {
    slug: string,
    name: string,
    summary: string,
    description: string,
    logo: string,
    featureKey?: string, // Billing feature which must be ordered before the integration can be used
    usesApiKey?: boolean, // Integration works through a crafter api key instead of a connector
    integrationsPage: {
        content: React.ComponentType<any>,
        actions: React.ComponentType<IntegrationPageActionsProps>
        form: React.ComponentType<{ viewKey?: string }>
    };
};

// Set the available integrations here
export const availableIntegrations: AvailableIntegration[] = [
    {
        "slug": "exact_online",
        "featureKey": "exact_integration",
        "name": "Exact Online",
        "summary": "integrations.general.exact_online_summary",
        "description": "integrations.general.exact_online_description",
        "logo": ExactOnlineLogo,
        "integrationsPage": {
            "content": ExactIntegrationPageContent,
            "form": ExactIntegrationForm,
            "actions": ExactIntegrationPageActions
        }
    },
    {
        "slug": "snelstart",
        "featureKey": "snelstart_integration",
        "name": "SnelStart",
        "summary": "integrations.general.snelstart_summary",
        "description": "integrations.general.snelstart_description",
        "logo": SnelStartLogo,
        "integrationsPage": {
            "content": SnelStartIntegrationPageContent,
            "form": SnelStartIntegrationForm,
            "actions": SnelStartIntegrationPageActions
        }
    },
    {
        "slug": "eboekhouden",
        "featureKey": "eboekhouden_integration",
        "name": "e-Boekhouden.nl",
        "summary": "integrations.general.eboekhouden_summary",
        "description": "integrations.general.eboekhouden_description",
        "logo": eBoekhoudenLogo,
        "integrationsPage": {
            "content": EBoekhoudenIntegrationPageContent,
            "form": EBoekhoudenIntegrationForm,
            "actions": EBoekhoudenIntegrationPageActions
        }
    },
    {
        "slug": "moneybird",
        "featureKey": "moneybird_integration",
        "name": "Moneybird",
        "summary": "integrations.general.moneybird_summary",
        "description": "integrations.general.moneybird_description",
        "logo": MoneybirdLogo,
        "integrationsPage": {
            "content": MoneybirdIntegrationPageContent,
            "form": MoneybirdIntegrationForm,
            "actions": MoneybirdIntegrationPageActions
        }
    },
    {
        "slug": "asperion",
        "featureKey": "asperion_integration",
        "name": "Asperion",
        "summary": "integrations.general.asperion_summary",
        "description": "integrations.general.asperion_description",
        "logo": AsperionLogo,
        "integrationsPage": {
            "content": AsperionIntegrationPageContent,
            "form": AsperionIntegrationForm,
            "actions": AsperionIntegrationPageActions
        }
    },
    {
        "slug": "isp_vision",
        "name": "ISP Vision",
        "summary": "integrations.general.isp_vision_summary",
        "description": "integrations.general.isp_vision_description",
        "logo": IspVisionLogo,
        "usesApiKey": true,
        "integrationsPage": {
            "content": IspVisionIntegrationPageContent,
            "form": IspVisionApiKeyForm,
            "actions": IspVisionIntegrationPageActions
        }
    },
    {
        "slug": "mkg",
        "featureKey": "mkg_integration",
        "name": "MKG",
        "summary": "integrations.general.mkg_summary",
        "description": "integrations.general.mkg_description",
        "logo": MkgLogo,
        "integrationsPage": {
            "content": MkgIntegrationPageContent,
            "form": MkgIntegrationForm,
            "actions": MkgIntegrationPageActions
        }
    }
];

// Get the integration details by slug
export const getAvailableIntegration = (slug: string) => availableIntegrations.find(integration => integration.slug === slug);